import { RrTracking } from './products/components/products-carousel';

export const getRRContentId = ({ id, rrTracking }: { id: string; rrTracking: RrTracking }) =>
  rrTracking.find((product) => product.productId === id)?.contentId;
